'use client'

import { Check } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

import type { TextColorOption } from './editor-color-picker.config'

export interface EditorColorSwatchProps {
  color: TextColorOption
  isCurrentColor: boolean
  onSelect: (value: string) => void
}

const swatchClasses = cn(
  'flex size-7 items-center justify-center rounded-md border transition-all',
  'hover:scale-110 hover:shadow-sm',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
)

/**
 * Individual color swatch button in the color picker grid
 */
export const EditorColorSwatch = ({ color, isCurrentColor, onSelect }: EditorColorSwatchProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        className={cn(
          swatchClasses,
          color.value === '' ? 'border-border bg-background' : 'border-transparent'
        )}
        style={{ backgroundColor: color.value || undefined }}
        onClick={() => onSelect(color.value)}
        aria-label={color.name}
      >
        {isCurrentColor && (
          <Check className={cn('size-4', color.value === '' ? 'text-foreground' : 'text-white')} />
        )}
        {color.value === '' && !isCurrentColor && (
          <span className="text-muted-foreground text-xs">Aa</span>
        )}
      </button>
    </TooltipTrigger>
    <TooltipContent side="bottom" sideOffset={5}>
      <p>{color.name}</p>
    </TooltipContent>
  </Tooltip>
)

EditorColorSwatch.displayName = 'EditorColorSwatch'
